import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Banner from '../Component/ContactUs/Banner'
import ContactForm from '../Component/ContactUs/ContactForm'
import Map from '../Component/ContactUs/Map'
import BrandSection from '../Component/HomePage/BrandSection'

function ContaactUs() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <ContactForm/>
        <Map/>
        <BrandSection/>
        <Footer/>
    </div>
  )
}

export default ContaactUs